import React, { useState, useEffect } from "react";
import ImageUploading from "react-images-uploading";
import "./ImageUploader.scss";
import campaignImg from "../../img/booking-confirmation-img.png";

export function ImageUploader({
    editMode,
    setImagesCallBack,
    showImagePreview = true,
    setShowImagePreview,
    imagesUpload = null
}) {
    const [images, setImages] = useState([]);

    useEffect(() => {
        let isMounted = true;

        const loadInitialImages = async () => {
            if (imagesUpload?.length > 0) {
                try {
                    const convertedImages = await convertImageList(imagesUpload);
                    if (isMounted) {
                        setImages(convertedImages);
                        setImagesCallBack(convertedImages);
                    }
                } catch (error) {
                    console.error('Error loading initial images:', error);
                    if (isMounted) {
                        setImages([]);
                        setImagesCallBack([]);
                    }
                }
            }
        };

        loadInitialImages();

        return () => {
            isMounted = false;
        };
    }, []);

    async function convertImageList(originalArray) {
        const baseUrl = 'https://www.funtlers.com/';

        return Promise.all(originalArray.map(async (item) => {
            try {
                
                const imageUrl = item.imageURL.replace('{baseApiURL}', baseUrl);
                const response = await fetch(imageUrl);

                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const blob = await response.blob();

                const dataUrl = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });

                return {
                    data_url: dataUrl,
                    file: {}
                };
            } catch (error) {
                console.error('Error processing image:', error);
                return {
                    data_url: item.imageURL.replace('{baseApiURL}', baseUrl),
                    file: {},
                    error: true
                };
            }
        }));
    }

    const maxNumber = 7;

    const onChange = (imageList) => {
        setImages(imageList);
        setImagesCallBack(imageList);
    };

    return (
        <div className="img_uploader_container">
            <ImageUploading
                multiple
                value={images}
                onChange={onChange}
                maxNumber={maxNumber}
                dataURLKey="data_url"
                acceptType={["jpg", "gif", "png", "jpeg"]}
            >
                {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                    dragProps,
                    errors,
                }) => (
                    <div> 
                        {/*<pre>{JSON.stringify(imageList, null, 2) }</pre>*/}
                        <div className="image-container" style={{ width: "100%" }}>
                            {imageList.length === 0 ? (
                                <img
                                    height={400}
                                    style={{ width: "100%" }}
                                    alt="default-img"
                                    src={campaignImg}
                                />
                            ) : (
                                imageList.map((image, index) => (
                                    <div key={index} className="image-item" style={{
                                        width: index === 0 ? "600px" : "99px"
                                    }} >
                                        <img
                                            src={image.data_url}
                                            alt={`uploaded-${index}`}
                                            style={{
                                                height: index === 0 ? 400 : 100,
                                                width: index === 0 ? "600px" : "99px"
                                            }}
                                        />
                                        <div className="image-actions">
                                            <button
                                                type="button"
                                                className="update-button"
                                                onClick={() => onImageUpdate(index)}
                                                title="Update"
                                            >
                                                <i className="ri-pencil-line"></i>
                                            </button>
                                            <button
                                                type="button"
                                                className="delete-button"
                                                onClick={() => onImageRemove(index)}
                                                title="Remove"
                                            >
                                                <i className="ri-delete-bin-5-line"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                        <div className="upload-actions">
                            <button
                                type="button"
                                onClick={onImageUpload}
                                className="form_btn Theme_btn_primary btn-primary-form"
                                {...dragProps}
                            >
                                <i className="ri-upload-2-line"></i>
                                {editMode ? "Endre bilde" : "Last opp bilde"}
                            </button>
                            {imageList.length > 0 && (
                                <button
                                    type="button"
                                    onClick={onImageRemoveAll}
                                    className="form_btn Theme_btn_secondary btn-primary-form"
                                >
                                    Fjern alle bilder
                                </button>
                            )}
                        </div>

                        {errors && (
                            <div className="error-messages">
                                {errors.maxNumber && (
                                    <span>Antall valgte bilder overskrider den tillatte grensen</span>
                                )}
                                {errors.acceptType && (
                                    <span>Den valgte filtypen er ikke tillatt</span>
                                )}
                                {errors.maxFileSize && (
                                    <span>Den valgte filst�rrelsen overskrider maksimalt tillatt st�rrelse</span>
                                )}
                                {errors.resolution && (
                                    <span>Den valgte filen samsvarer ikke med �nsket oppl�sning</span>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </ImageUploading>
        </div>
    );
}